import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import Footer from "../../components/footer/Footer";
import Header from "../../components/header/Header";
import MenuBar from "../../components/menu-bar/MenuBar";
import SideMenu from "../../components/side-menu/SideMenu";
import Slider from "react-slick";
import RenderItem from "../../common/renderItem";
import { useMediaQuery } from "react-responsive";
import { WebApiCalls } from "../../webApiCalls/webApiCalls";
import { formatCurrency } from "../../common/format-currency";
import moment from "moment";
import InfiniteScroll from "react-infinite-scroll-component";
import _ from "lodash";
import MyStorage from "../../common/MyStorage";
import { List } from "react-content-loader";
import {
  UpdateCartCount,
  UpdateCartAmount,
  setACF
} from "../../redux/actions/postActions";
import { KMTracking } from "../../components/Tracking/KMTracking";
import Loader from "react-loader-spinner";
import { Link } from 'react-router-dom';
import cleanURL from "../../common/cleanURL";
var kmViewedProductProps = {};
var kmViewedRefundsProps = {};

const MyListLoader = () => <List />;
function MyOrders(props) {
  const [orders, setOrders] = useState(false);
  const [refunds, setRefunds] = useState(false);
  const [moreProductAvailable, setMoreProductAvailable] = useState(true);
  const [moreRefundProductAvailable, setMoreRefundProductAvailable] =
    useState(true);
  const [myOrders, setMyOrders] = useState<any>([]);
  const [myRefunds, setMyRefunds] = useState<any>([]);
  const [is_loading, setIsLoading] = useState(false);
  const [productListTotalCount, setProductListTotalCount] = useState(0);
  const [refundProductListTotalCount, setRefundProductListTotalCount] =
    useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [pageNumber2, setPageNumber2] = useState(1);
  const [trendingProducts, setTrendingProducts] = useState([]);
  const [givenName, setGivenName] = useState("");
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });
  const isTabletOrMobileDevice = useMediaQuery({
    query: "(max-device-width: 1224px)",
  });

  useEffect(() => {
    const storage = new MyStorage();
    let userID = storage.getUserId();
    let accessToken = storage.getaccess_token();
    const token = storage.getloggedIn();
    if (token == "true") {
      const given_name = storage.getName()?.split(" ")[0];
      setGivenName(given_name ? given_name : "");
    } else {
      props?.history?.push("/login", { from: "My Orders" });
    }
    if (userID && accessToken) {
      seeCart()
    } else { props?.history?.push("/login", { from: "My Orders" }); }
    if (props?.match?.params?.isRefund == "refunds") {
      getRefundedAllInoviceofUser(1);
    } else {
      getAllInoviceofUser(1);
    }
    getTrendingProducts();
    if (props?.history?.location) {
      window.scrollTo(0, 0);
    }
  }, [props?.match?.params?.isRefund]);

  const tracker = async (eventName, _kmprops) => {
    await KMTracking(eventName, _kmprops);
  };
  const capitalizeFirstLetter = (string) => {
    return string.toString().charAt(0).toUpperCase() + string.slice(1);
  };
  const getAllInoviceofUser = (pageNumber = 1) => {
    setIsLoading(true);
    let accessToken = localStorage.getItem("access_token");
    let userID = localStorage.getItem("UserId");
    let recordsLength;

    new WebApiCalls()
      .getALlInvoices(userID, accessToken, pageNumber, 10)
      .then((_response) => {
        if (_response && _response.Records && _response.Records.length > 0) {
          recordsLength = _response.TotalRecords;
          kmViewedProductProps = {
            "Order count": recordsLength,
          };
          if (recordsLength > 0 && pageNumber == 1) {
            tracker("viewedmyorders", kmViewedProductProps);
          }
          if (productListTotalCount == _response.Records.length) {
            setProductListTotalCount(_response.Records.length + 1);
          } else {
            setProductListTotalCount(_response.Records.length);
          }
          if (pageNumber == 1) {
            setMyOrders([]);
          }
          let _temp: any = [];
          _response.Records.map(async (item: any) => {
            if (item?.Orders[0]?.CartItemDetails) {
              if (
                item?.Orders[0]?.CartItemDetails[0]?.ItemDetail?.Name.includes(
                  "Delivery"
                )
              ) {
                item.mainImage =
                  item?.Orders[1]?.CartItemDetails[0]?.ItemDetail?.Media[0]?.MediaUrl;
              } else {
                item.mainImage =
                  item?.Orders[0]?.CartItemDetails[0]?.ItemDetail?.Media[0]?.MediaUrl;
              }

              _temp = [..._temp, item];
            }
          });
          setMyOrders(myOrders.concat(_temp));
          setOrders(true);
          setIsLoading(false);
        } else {
          setMoreProductAvailable(false);
          setMyOrders([...myOrders]);
          setIsLoading(false);
          if (pageNumber == 1) {
            setOrders(false);
          }
        }
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };
  const seeCart = async () => {
    let userID = await localStorage.getItem("UserId");
    let accessToken = await localStorage.getItem("access_token");
    await new WebApiCalls()
      .getCartDetail(userID, accessToken)
      .then(async (Response) => {
        if (Response.errorType) {
          //redirect to login if expired
          props?.history?.push("/login", { from: 'My Orders' })
        }
      });
  };
  const getRefundedAllInoviceofUser = (pageNumber = 1) => {
    setIsLoading(true);
    let accessToken = localStorage.getItem("access_token");
    let userID = localStorage.getItem("UserId");
    let recordsLength;
    new WebApiCalls()
      .getALlInvoices(userID, accessToken, pageNumber, 20, true)
      .then((_response) => {
        recordsLength = _response.TotalRecords;
        kmViewedRefundsProps = {
          "Order count": recordsLength,
        };
        if (recordsLength > 0) {
          tracker("viewedRefunds", kmViewedRefundsProps);
        }
        if (_response.Records && _response.Records.length > 0) {
          //   this.sendMessage();
          if (refundProductListTotalCount == _response.Records.length) {
            setRefundProductListTotalCount(_response.Records.length + 1);
          } else {
            setRefundProductListTotalCount(_response.Records.length);
          }
          if (pageNumber == 1) {
            setMyRefunds([]);
          }
          let _temp: any = [];
          _response.Records.map(async (item, index) => {
            item.mainImage =
              item?.Orders[0]?.CartItemDetails[0]?.ItemDetail?.Media[0]?.MediaUrl;
            // kmViewedProductProps = {
            //   ...kmViewedProductProps,
            //   ...{ "Store Name": response.DisplayName },
            // };
            kmViewedProductProps = {
              ...kmViewedProductProps,
              ...{
                "invoice confirmation numberr": item.InvoiceNo,
                "order total": -item.Total,
              },
            };

            let refundDate = getRefundDate(item);
            item.RefundDate = refundDate;
            _temp = [..._temp, item];
          });
          let sorted = _.sortBy(_temp, ["RefundDate"], ["desc"]).reverse();
          setMyRefunds(myRefunds.concat(sorted));
          setOrders(true);
          setIsLoading(false);
        } else {
          setIsLoading(false);
          setMoreRefundProductAvailable(false);
          setMyRefunds([...myRefunds]);
          if (pageNumber2 == 1) {
            setOrders(false);
          }
        }
      });
  };
  const getRefundDate = (item) => {
    let refundDate = 0;
    item.Orders &&
      item.Orders.map((itemOuter) => {
        itemOuter.CartItemDetails &&
          itemOuter.CartItemDetails.map((itemInner) => {
            if (itemInner.Refund == true) {
              if (refundDate < itemInner.DateTimeCreated) {
                refundDate = itemInner.DateTimeCreated;
              }
            }
          });
      });
    return refundDate;
  };
  var ACF;
  const getTrendingProducts = async () => {
    if (!_.isEmpty(props?.acf)) {
      ACF = props?.acf
    }
    else {
      ACF = await new WebApiCalls().getCustomFieldsCode(true);
      props.setACF(ACF)
    }
    let customFieldQueries;
    if (ACF["Trending"] !== undefined) {
      customFieldQueries = [
        {
          Code: ACF["Trending"],
          Operator: "equal",
          Value: "1",
        },
      ];
    } else {
      customFieldQueries = [
        {
          Code: ACF["trending"],
          Operator: "equal",
          Value: "1",
        },
      ];
    }
    let tempArr: any = [];
    let itemObj = {
      CustomFieldQueries: customFieldQueries,
      Sort: "name",
    };
    let accessToken = await localStorage.getItem("access_token");
    await new WebApiCalls()
      .getItemsByFilters(itemObj, accessToken)
      .then((_response) => {
        if (_response?.Records) {
          tempArr = _response.Records;
        }
      })
      .catch((error) => console.log("Error: ", error));

    tempArr = tempArr.filter((item) => item.ID);
    setTrendingProducts(tempArr);
  };
  function NextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, display: "block", background: "white" }}
        onClick={onClick}
      >
        <div className="slick-next">
          <img src="images/next.png" />
        </div>
      </div>
    );
  }

  function PrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, display: "block", background: "white" }}
        onClick={onClick}
      >
        <div className="slick-prev">
          <img src="images/prev.png" />
        </div>
      </div>
    );
  }
  const onClickItem = (_item) => {
    props?.history?.push(
      `/product/${cleanURL(_item.Name)}/${_item.ID}`,
      { from: "My Orders" }
    );
  };
  const renderMiniSlider = (imgArray: any, slides: number) => {
    let settings = {
      dots: false,
      infinite: false,
      speed: 500,
      slidesToShow: slides,
      slidesToScroll: 1,
      arrows: false,
      autoplay: false,
      autoplaySpeed: 3000,
      centerMode: false,
      // nextArrow: <NextArrow />,
      // prevArrow: <PrevArrow />
    };
    return (
      <Slider {...settings}>
        {imgArray.slice(0, slides)?.map((item: any, index: number) => {
          if (!item.ID) {
            return;
          }
          return (
            <RenderItem
              item={item}
              onClickItem={onClickItem}
              is_slider={true}
              from={'My Orders'}
            />
          );
        })}
      </Slider>
    );
  };
  return (
    <div>
      <div className="viewport"></div>

      {/* /container */}
      <div className="container">
        {/* header */}
        <Header props={props} />
        {/* /header */}

        <MenuBar props={props} categoriesArray={props?.allCategories ? props?.allCategories : []} />

        {/* /content */}
        {orders == true ? (
          <div className="content">
            {/* breadcrumb */}
            <div
              className="breadcrumb"
              style={{ backgroundColor: "rgb(255,255,255,0.3)" }}
            >
              <Link to="/">Home</Link>
              <Link to="/my-orders">Orders</Link>
            </div>
            {/* /breadcrumb */}

            {/* product listing */}
            <div className="account-page">
              {/* two-columns */}
              <div className="two-columns">
                {/* left panel */}
                <SideMenu props={props} />
                {/* /left panel */}

                {/* /right panel */}
                <div className="right-panel">
                  {/* block-listing */}
                  {props?.match?.params?.isRefund !== "refunds" ? (
                    <div className="block-listing">
                      <InfiniteScroll
                        style={{}}
                        dataLength={productListTotalCount}
                        loader={
                          <div style={{ textAlign: "center" }}>
                            <Loader
                              type="TailSpin"
                              color="Black"
                              height={40}
                              width={40}
                            />
                          </div>
                        }
                        endMessage={<p style={{ textAlign: "center" }}></p>}
                        next={() => {
                          setPageNumber(pageNumber + 1);
                          getAllInoviceofUser(pageNumber + 1);
                        }}
                        hasMore={moreProductAvailable}
                        refreshFunction={() => {
                          getAllInoviceofUser();
                        }}
                        pullDownToRefresh={true}
                        pullDownToRefreshThreshold={50}
                      >
                        {/* item */}
                        {myOrders?.length > 0 &&
                          myOrders?.map((item: any, index: number) => {
                            let type =
                              item.Orders[0].CustomFields !== null
                                ? item.Orders[0].CustomFields.filter((item) =>
                                  item.Name.includes("CustomOrderType")
                                ).length > 0
                                  ? item.Orders[0].CustomFields.filter((item) =>
                                    item.Name.includes("CustomOrderType")
                                  )[0].Values[0]
                                  : ""
                                : "delivery";
                            return (
                              <div
                                key={index}
                                style={{
                                  boxShadow: "1px 1px 10px rgba(0,0,0,0.1)",
                                  margin: 10,
                                  backgroundColor: "white",
                                }}
                              >
                                <div
                                  className="item"
                                  style={{
                                    display: "flex",
                                    alignItems: "flex-start",
                                    padding: 20,
                                    color: "#000",

                                    textDecoration: "none",
                                    marginBottom: "30px",
                                  }}
                                >
                                  {/* thumb */}

                                  <div className="thumb">
                                    <img
                                      src={item?.mainImage}
                                      alt=""
                                      onClick={() => {
                                        props?.history?.push(
                                          `/order-details/${item?.InvoiceNo}`,
                                          { from: "my-orders" }
                                        );
                                      }}
                                    />
                                  </div>
                                  {/* /thumb */}

                                  {/* details */}
                                  <div
                                    className="details"
                                    onClick={() => {
                                      props?.history?.push(
                                        `/order-details/${item?.InvoiceNo}`,
                                        { from: "my-orders" }
                                      );
                                    }}
                                  >
                                    <div className="item">
                                      <span className="status">
                                        {/* {item?.InvoiceStatus} */}
                                        {item?.InvoiceStatus.toLowerCase() === "order delivered" ? "Order Completed" : item?.InvoiceStatus}
                                      </span>
                                    </div>
                                    <div className="item">
                                      <span>Order Date:</span>{" "}
                                      {moment
                                        .unix(item.Orders[0].CreatedDateTime)
                                        .format("DD MMM YYYY hh:mma")}
                                    </div>
                                    <div className="item">
                                      <span>Order Confirmation No:</span>{" "}
                                      {item?.InvoiceNo}
                                    </div>
                                    <div className="item">
                                      <span>Fulfilment:</span>{" "}
                                      {capitalizeFirstLetter(
                                        type == "pickup"
                                          ? "Self Collection"
                                          // : type
                                          : "delivery"
                                      )}
                                    </div>
                                    <div className="item">
                                      <span>Total:</span>{" "}
                                      {formatCurrency(item?.Total)}
                                    </div>
                                  </div>
                                  {/* details */}

                                  {/* view order */}
                                  <Link
                                    to={{pathname:`/order-details/${item?.InvoiceNo}`,state:{ from: "my-orders" }}}
                                    className="blackbutton">
                                    View Order
                                  </Link>
                                  {/* /view order */}
                                </div>
                              </div>
                            );
                          })}
                        {/* /item */}
                      </InfiniteScroll>
                    </div>
                  ) : (
                    <div className="block-listing">
                      <InfiniteScroll
                        style={{}}
                        dataLength={refundProductListTotalCount}
                        loader={
                          <div style={{ textAlign: "center" }}>
                            <Loader
                              type="TailSpin"
                              color="Black"
                              height={40}
                              width={40}
                            />
                          </div>
                        }
                        endMessage={<p style={{ textAlign: "center" }}></p>}
                        next={() => {
                          setPageNumber2(pageNumber2 + 1);
                          getRefundedAllInoviceofUser(pageNumber2);
                        }}
                        hasMore={moreRefundProductAvailable}
                        refreshFunction={() => {
                          getRefundedAllInoviceofUser();
                        }}
                        pullDownToRefresh={true}
                        pullDownToRefreshThreshold={50}
                      >
                        {/* item */}
                        {myRefunds?.length > 0 &&
                          myRefunds?.map((item: any, index: number) => {
                            let type =
                              item.Orders[0].CustomFields !== null
                                ? item.Orders[0].CustomFields.filter((item) =>
                                  item.Name.includes("CustomOrderType")
                                ).length > 0
                                  ? item.Orders[0].CustomFields.filter((item) =>
                                    item.Name.includes("CustomOrderType")
                                  )[0].Values[0]
                                  : ""
                                : "delivery";
                            return (
                              <div
                                style={{
                                  boxShadow: "1px 1px 10px rgba(0,0,0,0.1)",
                                  margin: 10,
                                  backgroundColor: "white",
                                }}
                                key={index}
                              >
                                <div
                                  className="item"
                                  style={{
                                    display: "flex",
                                    padding: 20,
                                    color: "#000",
                                    textDecoration: "none",
                                    marginBottom: "30px",
                                  }}
                                >
                                  {/* thumb */}
                                  <div className="thumb">
                                    <img
                                      src={item?.mainImage}
                                      alt=""
                                      onClick={() => {
                                        props?.history?.push(
                                          `/refund-details/${item?.InvoiceNo}`,
                                          { from: "my-orders" }
                                        );
                                      }}
                                    />
                                  </div>
                                  {/* /thumb */}

                                  {/* details */}
                                  <div
                                    className="details"
                                    onClick={() => {
                                      props?.history?.push(
                                        `/refund-details/${item?.InvoiceNo}`,
                                        { from: "my-orders" }
                                      );
                                    }}
                                  >
                                    <div className="item">
                                      <span className="status">{"Refund"}</span>
                                    </div>
                                    <div className="item">
                                      <span>Refund Date:</span>{" "}
                                      {moment
                                        .unix(item?.RefundDate)
                                        .format("DD MMM YYYY hh:mma")}
                                    </div>
                                    <div className="item">
                                      <span>Order Confirmation No:</span>{" "}
                                      {item?.InvoiceNo}
                                    </div>
                                    <div className="item">
                                      <span>Fulfilment:</span>{" "}
                                      {capitalizeFirstLetter(
                                        type == "pickup"
                                          ? "Self Collection"
                                          : type
                                      )}
                                    </div>
                                    <div className="item">
                                      <span>Total:</span>{" "}
                                      {formatCurrency(item?.Total)}
                                    </div>
                                  </div>
                                  {/* details */}

                                  {/* view order */}
                                  <Link
                                    to={{pathname:`/refund-details/${item?.InvoiceNo}`,state:{ from: "my-orders" }}}
                                    className="blackbutton">
                                    View Order
                                  </Link>
                                  {/* /view order */}
                                </div>
                              </div>
                            );
                          })}
                        {/* /item */}
                      </InfiniteScroll>
                    </div>
                  )}
                  {/* /block-listing */}
                </div>
                {/* /right panel */}
              </div>
              {/* /two-columns */}
            </div>
            {/* /product listing */}
          </div>
        ) : (
          <div className="content">
            {/* breadcrumb-back */}
            <div className="breadcrumb-back">
              {/* breadcrumb */}
              <div className="breadcrumb">
                <Link
                  to={'/'}
                >
                  Home
                </Link>
                {/* <a href="#">Account</a> */}
                {/* <a onClick={()=>{props?.history?.push("/my-orders")}}>My Orders</a> */}
                <Link
                  to={"/my-orders"}
                >
                  Orders
                </Link>
              </div>
              {/* /breadcrumb */}

              <a
                onClick={() => {
                  props?.history?.goBack();
                }}
                className="backbtn"
              >
                BACK
              </a>
            </div>
            {/* /breadcrumb-back */}

            {/* product listing */}
            <div className="account-page">
              {/* two-columns */}
              <div className="two-columns">
                {/* left panel */}
                <SideMenu props={props} />
                {/* /left panel */}

                {/* /right panel */}
                <div className="right-panel">
                  {is_loading ? (
                    <MyListLoader />
                  ) : (
                    <div className="no-order">
                      We could not find any orders.
                      <br />
                      <br />
                      <a href="#" className="blackbutton">
                        Shop now
                      </a>
                      <section className="related">
                        <div className="title capitalize">
                          These popular items might interest you
                        </div>

                        <div className="minicarousel four">
                          {isTabletOrMobile || isTabletOrMobileDevice
                            ? renderMiniSlider(trendingProducts, 2)
                            : renderMiniSlider(trendingProducts, 3)}
                        </div>
                      </section>
                    </div>
                  )}
                </div>
                {/* /right panel */}
              </div>
              {/* /two-columns */}
            </div>
            {/* /product listing */}
          </div>
        )}
        {/* /content*/}
      </div>

      <Footer props={props} categoriesArray={props?.allCategories ? props?.allCategories : []} />
    </div>
  );
}
const mapStateToProps = (state) => {
  const { cart_count, acf, allCategories } = state.UserReducer;
  return { cart_count, acf, allCategories };
};
const actions = {
  UpdateCartCount,
  UpdateCartAmount,
  setACF
};
export default connect(mapStateToProps, actions)(MyOrders);
